import React from 'react';
import styled from 'styled-components';

const SelectedItemsText = styled.div`
	color: #7d7d7d;
	font-size: 13px;
	font-weight: 600;
	margin-top: 4px;
	flex-shrink: 0;
`;

interface Props {
	selectedItemIds: string[];
	filteredItems?: any[]; // Adding filteredProducts to props
	items?: boolean;
}

export const SelectedItemsTextContainer: React.FC<Props> = ({
	selectedItemIds,
	filteredItems = [],
	items,
}) => {
	return selectedItemIds?.length ? (
		<SelectedItemsText>{selectedItemIds.length} items selected</SelectedItemsText>
	) : (
		<SelectedItemsText>
			{filteredItems.length} {items ? 'items' : 'products'} found
		</SelectedItemsText>
	);
};
